import React from "react";
import ReactDOM from "react-dom";
import { Provider } from 'react-redux';
import { CDN_BASE_URL } from "./Utils/constant";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { PublicKeyProvider } from "./context/PublicKeyProvider";

import { Router, Route, Switch } from 'react-router-dom';
import "react-table/react-table.css";
import "react-toastify/dist/ReactToastify.css";
import "react-confirm-alert/src/react-confirm-alert.css";
import "./Assets/css/style.css"
import "./Assets/css/responsive.css"

// import createHistory from 'history/createHashHistory';
import { createHashHistory as createHistory } from "history";
import { configureStore } from './store';
const history = createHistory()

const faviconLink = document.querySelector("link[rel='icon']");
if (faviconLink) {
    faviconLink.href = `${CDN_BASE_URL}/assets/sg-favicon.svg`;
  }


ReactDOM.render(
  <Provider store={configureStore()}>
    <PublicKeyProvider>
      <App history={history} />
    </PublicKeyProvider>
  </Provider>, 
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
